/**
 * This file is part of ONP.
 *
 * Copyright (c) 2013 Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Andrey Tkachenko <andrey.tkachenko@opensoftdev.ru>
 */

define(['jquery', 'assets/js/modules/Operation', 'assets/js/modules/cacheService'], function($, Operation, cacheService) {
    return Operation.extend({
        initialize: function(attrs, options) {
            var self = this;
            this._options = options || {};
            this._handler = null;

            if (!this._options.data) {
                this._options.data = function() {
                    return self.getObject();
                };
            }
        },

        terminate: function() {
            if (this._handler) {
                this.setFinished(Operation.TERMINATED);
                this._handler.abort();
            }

            return this;
        },

        start: function(object) {
            if (object) {
                this.set('object', object);
            }

            this.setStarted();

            if (this._options.useCache) {
                if (cacheService.has(this._options.cacheKey)) {
                    var response = cacheService.get(this._options.cacheKey);
                    this.ajaxSuccess.apply(this, [response]);

                    return this;
                }
            }

            this._handler = this._createAjaxRequest();

            return this;
        },

        resume: function() {
            return this;
        },
        stop: function() {
            return this;
        },

        ajaxStart: function() {
            if (this._options.ajaxStart) {
                this._options.ajaxStart.apply(this, arguments);
            } else {
                this.data = this.getObject();
            }
        },

        ajaxSuccess: function(result) {
            if (this._options.ajaxSuccess) {
                this._options.ajaxSuccess.apply(this, arguments);
            } else {
                this.setFinished(Operation.SUCCESS, result);
            }
        },

        ajaxError: function() {
            if (this._options.ajaxError) {
                this._options.ajaxError.apply(this, arguments);
            } else {
                this.setFinished(Operation.ERROR); //TODO set message
            }
        },

        _createAjaxRequest: function() {
            var self = this;

            var url = typeof this._options.url == 'function' ? this._options.url.call(this) : this._options.url;

            var data = typeof this._options.data == 'function' ? this._options.data.call(this) : this._options.data;

            if (this._options.contentType === 'application/json') {
                data = JSON.stringify(data);
            }

            self.ajaxStart();
            $.ajax({
                url: url,
                type: this._options.type,
                dataType: this._options.dataType,
                contentType: this._options.contentType,
                data: data,
                beforeSend: function(XMLHttpRequest) {
                    XMLHttpRequest.progress(function(event) {
                        if (event.lengthComputable) {
                            self.setProgress(event.loaded / event.total * 100);
                        }
                    });
                },
                success: function(data, status, xhr) {
                    if (self._options.useCache) {
                        cacheService.set(self._options.cacheKey, data);
                    }
                    self.ajaxSuccess.apply(self, arguments);
                },
                error: function() {
                    if (self.getStatus() != Operation.TERMINATED) {
                        self.ajaxError.apply(self, arguments);
                    }
                }
            });
        }
    });
});
